import client from './client';
export interface NodePlugin { key:string; name:string; description:string; icon:string; depends_on:string[]; enabled:boolean }
export const listPlugins = (proxyID:number) => client.get<{items:NodePlugin[]}>('/api/plugins',{params:{proxy_id:proxyID}});
export const setProxyPlugin = (proxyID:number,key:string,enabled:boolean) => client.put(`/api/proxies/${proxyID}/plugins/${key}`,{enabled});
